module.exports = __webpack_public_path__ + "fde19c02aae8f0766bbc25dd5fc47090.png";